// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + "reactPlayerPreview" + "." + "4ab8019c" + ".chunk.js";
};